import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, btnPrimary, card, InlineError, input, labelCls } from '../components/ui/Kit';

// The invite link: /activate?token=… — shows who and which company, then sets the password.
export default function ActivatePage() {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (!token) { setError('This invite link is incomplete — open the link from your e-mail again.'); return; }
    api(`/api/auth/invite?token=${encodeURIComponent(token)}`).then(setInfo).catch((e) => setError(e.message));
  }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (pw.length < 8) { setError('Use at least 8 characters for your password'); return; }
    if (pw !== pw2) { setError('Passwords do not match'); return; }
    setBusy(true);
    try { await api('/api/auth/activate', { method: 'POST', body: { token, password: pw, confirm_password: pw2 } }); setDone(true); }
    catch (err) { setError(err.message); setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#F5F7FB] font-inter flex items-center justify-center p-4">
      <div className={card + ' w-full max-w-md p-8'}>
        <img src="/Reqt5d-Logo.png" alt="Quali5d" className="h-12 mb-6" />
        {done ? (
          <>
            <h1 className="text-xl font-extrabold text-[#0F172A]">You're all set</h1>
            <p className="text-sm text-[#64748B] mt-2">Your account is ready. Log in with your e-mail and the password you just chose.</p>
            <button className={btnPrimary + ' mt-6 w-full justify-center'} onClick={() => navigate('/')}>Go to log in</button>
          </>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <h1 className="text-xl font-extrabold text-[#0F172A]">{info ? `Join ${info.company_name} on Quali5d` : 'Set up your account'}</h1>
              {info && <p className="text-sm text-[#64748B] mt-1">{info.full_name} · {info.email}</p>}
            </div>
            <InlineError>{error}</InlineError>
            {info && (
              <>
                <label className="block"><span className={labelCls}>Choose a password</span>
                  <input className={input} type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} /></label>
                <label className="block"><span className={labelCls}>Confirm password</span>
                  <input className={input} type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} /></label>
                <p className="text-xs text-[#64748B]">At least 8 characters.</p>
                <button className={btnPrimary + ' w-full justify-center'} disabled={busy} type="submit">{busy ? 'Setting up…' : 'Activate my account'}</button>
              </>
            )}
          </form>
        )}
      </div>
    </div>
  );
}
